import React, { useState, useCallback, useEffect, useRef } from "react";
import { Plus, Minus } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { debounce } from "lodash";
import { useToast } from "../../Utils/toastContext";
import countriesData from "../../Data/CountryCodes.json";
import { useSelector, useDispatch } from "react-redux";
import {
  clearStepStatusShareholder,
  clearCurrentStepShareholder,
} from "../../Redux/store/onboardingFormSlice";
import LabelWithStatus from "../../Components/onboarding/label-with-status";
import Select, { components } from "react-select";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import { clearFileIdsRedux } from "../../Redux/store/userSlice";
import { updateField } from "../../Redux/store/onboardingFormSlice";
const validator = require("validator");

/**
 * TrusteesPanel.jsx
 * - Corporate tab: corporate rows with nested directors
 * - Individual tab: simple flat table
 *
 * Notes:
 * - Styling uses Tailwind classes
 * - Replace images/icons paths with your assets if needed
 */

export default function TrusteesPanel({
  containerClass = "",
  isEdit,
  trusteeResponse,
  trusteeName,
  isShareholder,
  shareholderId,
}) {
  const [activeTab, setActiveTab] = useState("individual"); // "corporate" | "individual"
  const [members, setMembers] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [options, setOptions] = useState([]);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [countries, setCountries] = useState([]);
  const [signatoryType, setSignatoryType] = useState(1);
  const [signatoriesData, setSignatoriesData] = useState([]);
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [shareholderTypesData, setShareholderTypesData] = useState([]);
  const [limitData, setLimitData] = useState([]);
  const [customDate, setCustomDate] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isFocusedAccountFee, setIsFocusedAccountFee] = useState(false);
  const isInviteeTrustee = useSelector((state) => state.user.isInviteeTrustee);
  // corporate structure: { id, companyName, beneficialOwner: boolean, directors: [], expanded }
  const [corporates, setCorporates] = useState([]);
  const { showToast } = useToast();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState("");
  const [loading, setLoading] = useState(false);
  const [fileAttorney, setFileAttorney] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [currentDocument, setcurrentDocument] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [signatoryId, setSignatoryId] = useState("");
  const [signatoryText, setSignatoryText] = useState("");
  const [signatoryEmail, setSignatoryEmail] = useState("");
  const [preSelectedSignatoryType, setPreSelectedSignatoryType] = useState({
    value: 1,
    label: "1 to Sign",
  });
  const [minimumInvestment, setminimumInvestment] = useState({
    verification_id: null,
    value: 0,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const inputRefAccountFee = useRef(null);
  const [selected, setSelected] = useState("never");

  const [limitDurationId, setLimitDurationId] = useState(1);
  const [limitDurationLabel, setLimitDurationLabel] = useState("Per Day");
  const [preSelectedDurationType, setPreSelectedDurationType] = useState({
    value: 1,
    label: "Per Day",
  });
  const [signatoryTypeData, setsignatoryTypeData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const dropdownRef = useRef();
  const dateInputRef = useRef(null);
  const optionsdate = [
    { label: "Never Expire", value: "never" },
    { label: "Set Custom Date", value: "custom" },
  ];
  // individuals: { id, firstName, lastName, email, phone, managing? (radio across individuals) }
  const [individuals, setIndividuals] = useState([]);
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };
  const formatNumber = (value) => {
    // Remove commas before parsing
    const number = parseFloat(value.toString().replace(/,/g, ""));

    if (isNaN(number)) return "";

    // Format with 2 decimal places and add commas
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const handleSelectSignatoryType = (selectedOption) => {
    setSignatoryType(selectedOption.value);
    dispatch(
      updateField({
        path: "signatoryType",
        value: selectedOption.value,
      }),
    );
    setSignatoryTypeLabel(selectedOption.label);
    if (selectedOption.value == 3) {
      setSelectedOptions(options);
      dispatch(
        updateField({
          path: "selectedOptions",
          value: options,
        }),
      );
    }
  };
  const fieldLabelMap = {
    board_resolution_file: "Board Resolution",
    transaction_limit_amount: "Amount in Dollars($)",
    transaction_limit_expiry: "Transaction Limit Expiry Date",
  };
  // Helper: validation
  const isValidEmail = (v) =>
    !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());
  const validateRequired = (val, msg) => (val?.trim() ? "" : msg);

  const validateEmail = (val) =>
    isValidEmail(val) ? "" : "Enter a valid email address";

  const validateMobile = (code, val) =>
    validator.isMobilePhone(code + val, "any")
      ? ""
      : "Enter a valid mobile number";
  const customStyles = {
    clearIndicator: () => ({ display: "none" }), // removes the cross
    indicatorSeparator: () => ({ display: "none" }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: "white", // hover/focus
      color: "black",
      cursor: "pointer",
      ":active": {
        backgroundColor: "white", // prevent blue flash on click
      },
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: "#d1d5db", // Tailwind gray-300
      boxShadow: "none", // remove blue focus ring
      "&:hover": { borderColor: "#d1d5db" },
    }),
    multiValue: (provided) => ({
      ...provided,
      backgroundColor: "#FCFCFC",
      border: "1px solid #E5E7EB", // Tailwind gray-200
      borderRadius: "10px",
    }),
    multiValueLabel: (provided) => ({
      ...provided,
      color: "#374151", // Tailwind gray-700
    }),
    multiValueRemove: (provided) => ({
      ...provided,
      color: "#374151",
      ":hover": { backgroundColor: "white", color: "" }, // red remove hover
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-4 w-4 text-black" // 👈 black icon
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </components.DropdownIndicator>
    );
  };
  const handleSelectSignatory = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setSignatoryId(selectedOption.value);
    setSignatoryText(selectedOption.label);
    setSignatoryEmail(selectedOption.email);
    dispatch(
      updateField({
        path: "signatoryEmail",
        value: selectedOption.email,
      }),
    );
  };
  // CORPORATE ACTIONS
  function addCorporate() {
    setCorporates((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        companyName: "",
        beneficialOwner: false,
        expanded: true,
        corporateId: "",
        directors: [],
      },
    ]);
  }
  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={props.isSelected}
            onChange={() => null} // handled by react-select
            className="flex-shrink-0 custom-checkbox"
          />
          <span className="truncate">{props.label}</span>
        </div>
      </components.Option>
    );
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  function removeCorporate(index) {
    setCorporates((prev) => prev.filter((_, i) => i !== index));
  }

  function toggleCorporateExpand(index) {
    setCorporates((prev) =>
      prev.map((c, i) => (i === index ? { ...c, expanded: !c.expanded } : c)),
    );
  }

  function toggleBeneficial(index) {
    setCorporates((prev) =>
      prev.map((c, i) =>
        i === index ? { ...c, beneficialOwner: !c.beneficialOwner } : c,
      ),
    );
  }
  function updateCorporateField(index, key, value) {
    setCorporates((prev) =>
      prev.map((c, i) => {
        if (i !== index) return c;

        const errors = { ...(c.errors || {}) };

        // 🔴 Company name validation
        if (key === "companyName") {
          if (!value.trim()) {
            errors.companyName = "Company name is required";
          } else {
            delete errors.companyName;
          }
        }

        return {
          ...c,
          [key]: value,
          errors,
        };
      }),
    );
  }
  const handleSelectDurationType = (selectedOption) => {
    console.log("Selected Option:", selectedOption.value);
    setLimitDurationId(selectedOption.value);
    setLimitDurationLabel(selectedOption.label);
    dispatch(
      updateField({
        path: "limitDurationId",
        value: selectedOption.value,
      }),
    );
  };
  const getEnums = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/corporate/directors-n-shareholders/enums`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.signatory_types.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setsignatoryTypeData(AccountData);
        setPreSelectedSignatoryType(AccountData[0]);

        const shareholderTypes = [];
        response.data.shareholder_types.forEach((profile) => {
          shareholderTypes.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setShareholderTypesData(shareholderTypes);

        const limitTypes = [];
        response.data.transaction_limits.forEach((profile) => {
          limitTypes.push({
            value: profile.id,
            label: profile.name,
          });
        });
        setLimitData(limitTypes);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setsignatoryTypeData([]);
          setPreSelectedSignatoryType({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setsignatoryTypeData([]);
      setPreSelectedSignatoryType({});
    } finally {
    }
  };
  const handleDeleteFile = () => {
    setFileAttorney({
      verification_id: null,
      value: null,
      status: "pending",
      rejection_reason: null,
      rejection_comment: null,
      rejection_timestamp: null,
      rejected_by: null,
      comments: [],
    });
    dispatch(
      updateField({
        path: "fileAttorney",
        value: {
          verification_id: null,
          value: null,
          status: "pending",
          rejection_reason: null,
          rejection_comment: null,
          rejection_timestamp: null,
          rejected_by: null,
          comments: [],
        },
      }),
    );
  };
  const fileUploadNew = async (file) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/onboarding/upload/file`;
    const formData3 = new FormData();
    formData3.append("file", file); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const handleChangeAmountFee = (e, amountValue) => {
    e.preventDefault();
    const rawValue = e.target.value.replace(/,/g, ""); // Remove commas

    if (!isNaN(rawValue) || rawValue === "") {
      const cursorPosition = e.target.selectionStart;

      setminimumInvestment({
        ...minimumInvestment,
        value: rawValue,
      });

      dispatch(
        updateField({
          path: "minimumInvestment",
          value: {
            ...minimumInvestment,
            value: rawValue,
          },
        }),
      ); // Wait for state update before restoring cursor position
      setTimeout(() => {
        if (inputRefAccountFee.current) {
          inputRefAccountFee.current.setSelectionRange(
            cursorPosition,
            cursorPosition,
          );
        }
      }, 0);
    }
  };
  const handleFileChangeAttorney = async (e) => {
    const selectedFile = e.target.files[0];
    let toastMessage = null;
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setLoading(true);
        try {
          const response = await fileUploadNew(selectedFile);
          if (response.status == 201) {
            setFileAttorney({
              ...fileAttorney,
              value: response.data,
            });
            dispatch(
              updateField({
                path: "fileAttorney",
                value: {
                  ...fileAttorney,
                  value: response.data,
                },
              }),
            );
          } else {
            toastMessage = { message: response.message, type: "error" };
          }
        } catch (err) {
          setFileAttorney({
            verification_id: null,
            value: null,
            status: "pending",
            rejection_reason: null,
            rejection_comment: null,
            rejection_timestamp: null,
            rejected_by: null,
            comments: [],
          });
          dispatch(
            updateField({
              path: "fileAttorney",
              value: {
                verification_id: null,
                value: null,
                status: "pending",
                rejection_reason: null,
                rejection_comment: null,
                rejection_timestamp: null,
                rejected_by: null,
                comments: [],
              },
            }),
          );
          toastMessage = { message: err.message, type: "error" };
        } finally {
          setLoading(false); // Ensure `loading` is false first
          // Show toast after loading is false
          if (toastMessage) {
            setTimeout(() => {
              showToast(toastMessage.message, toastMessage.type);
            }, 300); // Small delay if needed
          }
        }
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error",
        );
      }
    }
    e.target.value = "";
  };
  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    dispatch(clearFileIdsRedux());
    setShowPopup(true);
  };
  // DIRECTORS ACTIONS (per corporate)
  function addDirector(corpIndex) {
    setCorporates((prev) =>
      prev.map((c, i) =>
        i === corpIndex
          ? {
              ...c,
              directors: [
                ...c.directors,
                {
                  id: Date.now() + Math.random(),
                  firstName: "",
                  lastName: "",
                  email: "",
                  phone: "",
                  managing: false,
                },
              ],
            }
          : c,
      ),
    );
  }
  const addIndividualAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = isShareholder
      ? `${BASE_URL}/v1/onboarding/stakeholder/trust/trustee-and-beneficiaries/individual-trustees/${shareholderId}`
      : `${BASE_URL}/v1/onboarding/trust/trustee-beneficiaries/trustees/individual`;
    const payload = {
      invitees: individuals.map((item) => ({
        first_name: item.firstName,
        last_name: item.lastName,
        email: item.email,
        country_code: item.countryCode,
        mobile_number: item.mobile,
        managing_member: item.managing || false,
        beneficial_owner: item.beneficialOwner || false,
      })),
    };

    const bodyData = payload;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddIndividuals = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addIndividualAPI();
        if (response.status == 200) {
          showToast(response.message, "success");
          getIndividuals();
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [individuals],
  );
  const handleSelect = (option) => {
    setSelected(option.value);
    setIsOpen(false);
    setCustomDate("");
    dispatch(
      updateField({
        path: "selected",
        value: option.value,
      }),
    );
    dispatch(
      updateField({
        path: "customDate",
        value: "",
      }),
    );
  };
  const addCorporateAPI = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = isShareholder
      ? `${BASE_URL}/v1/onboarding/stakeholder/trust/trustee-and-beneficiaries/corporate-trustees/${shareholderId}`
      : `${BASE_URL}/v1/onboarding/trust/trustee-beneficiaries/trustees/corporate`;
    let payload = {
      trustees: corporates.map((item) => ({
        company_name: item.companyName,
        beneficial_owner: item.beneficialOwner,
        // managing_member: false,
      })),
    };

    const bodyData = payload;
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleAddCorporates = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await addCorporateAPI();
        if (response.status == 200) {
          showToast(response.message, "success");
          getCorporates();
        } else {
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [corporates],
  );
  const getIndividuals = async () => {
    try {
      const response = await GetAPIcalls(
        isShareholder
          ? `/v1/onboarding/stakeholder/trust/trustee-and-beneficiaries/individual-trustees/${shareholderId}`
          : `/v1/onboarding/trust/trustee-beneficiaries/trustees/individual`,
      );

      if (response.status == 200) {
        const AccountData = [];
        response.data.forEach((profile) => {
          AccountData.push({
            value: profile.id,
            label: profile.first_name + " " + profile.last_name,
            email: profile.email,
          });
        });
        setOptions(AccountData);
        dispatch(
          updateField({
            path: "options",
            value: AccountData,
          }),
        );
        setSignatoriesData(AccountData);
        setIndividuals(
          response.data.map((item) => ({
            firstName: item.first_name, // or Date.now() if you want local-only IDs
            lastName: item.last_name,
            countryCode: item.country_code, // 1 = Individual, 2 = Corporate, 3 = Trust
            mobile: item.mobile_number,
            email: item.email,
            managing: item.managing_member,
            beneficialOwner: item.beneficial_owner,
          })),
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };

  const getCorporates = async () => {
    try {
      const response = await GetAPIcalls(
        isShareholder
          ? `/v1/onboarding/stakeholder/trust/trustee-and-beneficiaries/corporate-trustees/${shareholderId}`
          : `/v1/onboarding/trust/trustee-beneficiaries/trustees/corporate`,
      );

      if (response.status == 200) {
        setCorporates(
          response.data.map((item) => ({
            companyName: item.company_name, // or Date.now() if you want local-only IDs
            beneficialOwner: item.beneficial_owner,
            corporateId: item.corporate_user_id,
            directors: item?.directors,
            expanded: false,
            status: item.status,
          })),
        );
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  function removeDirector(corpIndex, dirIndex) {
    setCorporates((prev) =>
      prev.map((c, i) =>
        i === corpIndex
          ? { ...c, directors: c.directors.filter((_, j) => j !== dirIndex) }
          : c,
      ),
    );
  }

  function updateDirectorField(corpIndex, dirIndex, key, value) {
    setCorporates((prev) =>
      prev.map((c, i) =>
        i === corpIndex
          ? {
              ...c,
              directors: c.directors.map((d, j) =>
                j === dirIndex ? { ...d, [key]: value } : d,
              ),
            }
          : c,
      ),
    );
  }

  function setManagingMember(corpIndex, dirIndex) {
    // radio: only one director per corporate can be managing
    setCorporates((prev) =>
      prev.map((c, i) =>
        i === corpIndex
          ? {
              ...c,
              directors: c.directors.map((d, j) => ({
                ...d,
                managing: j === dirIndex,
              })),
            }
          : c,
      ),
    );
  }

  // INDIVIDUAL ACTIONS (simple table)
  function addIndividual() {
    setIndividuals((prev) => [
      ...prev,
      {
        id: Date.now() + Math.random(),
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        managing: false,
      },
    ]);
  }

  function removeIndividual(index) {
    setIndividuals((prev) => prev.filter((_, i) => i !== index));
  }

  function updateIndividualField(index, key, value, error = "") {
    setIndividuals((prev) =>
      prev.map((m, i) =>
        i === index
          ? {
              ...m,
              [key]: value,
              errors: {
                ...m.errors,
                ...(error !== undefined ? { [key]: error } : {}),
              },
            }
          : m,
      ),
    );
  }

  // Managing radio for individuals (if you need single managing across individuals)
  function setManagingIndividual(index) {
    setIndividuals((prev) =>
      prev.map((m, i) => ({ ...m, managing: i === index })),
    );
  }
  function toggleBeneficialIndividiual(index) {
    setIndividuals((prev) =>
      prev.map((m, i) => ({ ...m, beneficialOwner: i === index })),
    );
  }
  useEffect(() => {
    setCountries(countriesData);
    getEnums();
    getCorporates();
    getIndividuals();
  }, []);

  useEffect(() => {
    if (trusteeResponse != null && isEdit) {
      let response = trusteeResponse;
      if (response.data) {
        const signatoryTypeValue = response?.data?.signatory_type?.value;

        if (!signatoryTypeValue) return;

        // ─── Common state ─────────────────────────────────────────────
        setPreSelectedSignatoryType({
          value: signatoryTypeValue.id,
          label: signatoryTypeValue.name,
        });
        setSignatoryType(signatoryTypeValue.id);
        dispatch(
          updateField({
            path: "signatoryType",
            value: signatoryTypeValue.id,
          }),
        );
        setSignatoryTypeLabel(signatoryTypeValue.name);

        // ─── 1 TO SIGN ────────────────────────────────────────────────
        if (signatoryTypeValue.id === 1) {
          setSignatoryEmail(response?.data?.signatories?.value?.[0] || null);
          dispatch(
            updateField({
              path: "signatoryEmail",
              value: response?.data?.signatories?.value?.[0] || null,
            }),
          );
        }

        // ─── Build invitee options once ───────────────────────────────
        const inviteeOptions =
          response?.invitees?.map((invitee) => ({
            label: `${invitee.first_name} ${invitee.last_name}`,
            value: invitee.id,
            email: invitee.email,
          })) || [];

        // ─── Match signatories by email ───────────────────────────────
        const signatoryEmails =
          response?.data?.signatories?.value?.map((s) => s.email) || [];

        const matchedInvitees = inviteeOptions.filter((invitee) =>
          signatoryEmails.includes(invitee.email),
        );

        // ─── MULTIPLE / ALL TO SIGN ───────────────────────────────────
        switch (signatoryTypeValue.id) {
          case 2: // Selected signatories
            setSelectedOptions(matchedInvitees);
            dispatch(
              updateField({
                path: "selectedOptions",
                value: matchedInvitees,
              }),
            );
            break;

          case 3: // All invitees
            setSelectedOptions(inviteeOptions);
            dispatch(
              updateField({
                path: "selectedOptions",
                value: inviteeOptions,
              }),
            );
            break;

          default:
            break;
        }
        setFileAttorney(response.data.board_resolution_file);
        dispatch(
          updateField({
            path: "fileAttorney",
            value: response.data.board_resolution_file,
          }),
        );
        setPreSelectedDurationType({
          value: response.data.transaction_limit_duration.value.id,
          label: response.data.transaction_limit_duration.value.name,
        });
        setLimitDurationId(response.data.transaction_limit_duration.value.id);
        dispatch(
          updateField({
            path: "limitDurationId",
            value: response.data.transaction_limit_duration.value.id,
          }),
        );
        setLimitDurationLabel(
          response.data.transaction_limit_duration.value.name,
        );
        setminimumInvestment(response.data.transaction_limit_amount);
        dispatch(
          updateField({
            path: "minimumInvestment",
            value: response.data.transaction_limit_amount,
          }),
        );
        const expiryValue = response?.data?.transaction_limit_expiry?.value;
        if (!expiryValue) {
          setSelected("never");
          dispatch(
            updateField({
              path: "selected",
              value: "never",
            }),
          );
        } else {
          setSelected("custom");
          setCustomDate(response?.data?.transaction_limit_expiry);
          dispatch(
            updateField({
              path: "selected",
              value: "custom",
            }),
          );
          dispatch(
            updateField({
              path: "customDate",
              value: response?.data?.transaction_limit_expiry,
            }),
          );
        }
      } else {
        setPreSelectedSignatoryType({
          value: 1,
          label: "1 to Sign",
        });
        setSignatoryType(1);
        dispatch(
          updateField({
            path: "signatoryType",
            value: 1,
          }),
        );
        setSignatoryTypeLabel("");
        setSignatoryEmail("");
        dispatch(
          updateField({
            path: "signatoryEmail",
            value: "",
          }),
        );
        setSelectedOptions([]);
        dispatch(
          updateField({
            path: "selectedOptions",
            value: [],
          }),
        );
        setFileAttorney({
          verification_id: null,
          value: null,
          status: "pending",
          rejection_reason: null,
          rejection_comment: null,
          rejection_timestamp: null,
          rejected_by: null,
          comments: [],
        });
        dispatch(
          updateField({
            path: "fileAttorney",
            value: {
              verification_id: null,
              value: null,
              status: "pending",
              rejection_reason: null,
              rejection_comment: null,
              rejection_timestamp: null,
              rejected_by: null,
              comments: [],
            },
          }),
        );
        setPreSelectedDurationType({
          value: 1,
          label: "Per Day",
        });
        setLimitDurationId(1);
        dispatch(
          updateField({
            path: "limitDurationId",
            value: 1,
          }),
        );
        setLimitDurationLabel("Per Day");
        setminimumInvestment({
          verification_id: null,
          value: 0,
          status: "pending",
          rejection_reason: null,
          rejection_comment: null,
          rejection_timestamp: null,
          rejected_by: null,
          comments: [],
        });
        dispatch(
          updateField({
            path: "minimumInvestment",
            value: {
              verification_id: null,
              value: 0,
              status: "pending",
              rejection_reason: null,
              rejection_comment: null,
              rejection_timestamp: null,
              rejected_by: null,
              comments: [],
            },
          }),
        );
        setSelected("never");
        setCustomDate("");
        dispatch(
          updateField({
            path: "selected",
            value: "never",
          }),
        );
        dispatch(
          updateField({
            path: "customDate",
            value: "",
          }),
        );
      }
    }
    if (trusteeResponse != null && !isEdit) {
      let response = trusteeResponse;
        const signatoryTypeValue = response?.signatory_type;

        if (!signatoryTypeValue) return;

        // ─── Common state ─────────────────────────────────────────────
        setPreSelectedSignatoryType({
          value: signatoryTypeValue.id,
          label: signatoryTypeValue.name,
        });
        setSignatoryType(signatoryTypeValue.id);
        dispatch(
          updateField({
            path: "signatoryType",
            value: signatoryTypeValue.id,
          }),
        );
        setSignatoryTypeLabel(signatoryTypeValue.name);

        // ─── 1 TO SIGN ────────────────────────────────────────────────
        if (signatoryTypeValue.id === 1) {
          setSignatoryEmail(response?.signatories?.[0] || null);
          dispatch(
            updateField({
              path: "signatoryEmail",
              value: response?.signatories?.[0] || null,
            }),
          );
        }

        // ─── Build invitee options once ───────────────────────────────
        const inviteeOptions =
          response?.invitees?.map((invitee) => ({
            label: `${invitee.first_name} ${invitee.last_name}`,
            value: invitee.id,
            email: invitee.email,
          })) || [];

        // ─── Match signatories by email ───────────────────────────────
        const signatoryEmails =
          response?.signatories?.map((s) => s.email) || [];

        const matchedInvitees = inviteeOptions.filter((invitee) =>
          signatoryEmails.includes(invitee.email),
        );

        // ─── MULTIPLE / ALL TO SIGN ───────────────────────────────────
        switch (signatoryTypeValue.id) {
          case 2: // Selected signatories
            setSelectedOptions(matchedInvitees);
            dispatch(
              updateField({
                path: "selectedOptions",
                value: matchedInvitees,
              }),
            );
            break;

          case 3: // All invitees
            setSelectedOptions(inviteeOptions);
            dispatch(
              updateField({
                path: "selectedOptions",
                value: inviteeOptions,
              }),
            );
            break;

          default:
            break;
        }
        setFileAttorney(response.board_resolution_file);
        dispatch(
          updateField({
            path: "fileAttorney",
            value: response.board_resolution_file,
          }),
        );
        setPreSelectedDurationType({
          value: response.transaction_limit_duration.id,
          label: response.transaction_limit_duration.name,
        });
        setLimitDurationId(response.transaction_limit_duration.id);
        dispatch(
          updateField({
            path: "limitDurationId",
            value: response.transaction_limit_duration.id,
          }),
        );
        setLimitDurationLabel(response.transaction_limit_duration.name);
        setminimumInvestment(response.transaction_limit_amount);
        dispatch(
          updateField({
            path: "minimumInvestment",
            value: response.transaction_limit_amount,
          }),
        );
        const expiryValue = response?.transaction_limit_expiry;
        if (!expiryValue) {
          setSelected("never");
          dispatch(
            updateField({
              path: "selected",
              value: "never",
            }),
          );
        } else {
          setSelected("custom");
          setCustomDate(response?.transaction_limit_expiry);
          dispatch(
            updateField({
              path: "selected",
              value: "custom",
            }),
          );
          dispatch(
            updateField({
              path: "customDate",
              value: response?.transaction_limit_expiry,
            }),
          );
        }

    }
  }, [trusteeResponse, isEdit]);
  return (
    <div
      className={`bg-white shadow-md rounded-md p-4 flex flex-col min-h-[calc(100vh-100px)] ${containerClass}`}
    >
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="flex flex-wrap items-center justify-between mb-4">
        {/* Left Side - Heading */}
        <div className="flex items-center space-x-2">
          <img src="/people.svg" alt="User Avatar" className="h-6 w-6" />
          <h1 className="text-xl font-medium">
            Trustees:
            <span className="text-xl font-medium text-[#8C8C8C] ml-1">
              {trusteeName}
            </span>
          </h1>
        </div>

        {/* Right Side - Info */}
        {isEdit && (
          <p
            className="text-[10px] mt-2 md:mt-0 text-[#363636] bg-[#363636] bg-opacity-20 
              px-2 py-1 border border-gray-300 rounded-lg max-w-xs md:max-w-sm"
          >
            Information of all the Trustees must be added. Please ensure before
            submitting the form. Failing to do so will lead in resubmitting the
            application.
          </p>
        )}
      </div>

      {/* Tabs */}
      <div className="flex items-center bg-gray-100 font-medium text-sm mb-4">
        <button
          className={`px-4 py-2  ${
            activeTab === "individual"
              ? "bg-white border-t border-l border-r shadow-sm"
              : "bg-gray-100"
          }`}
          onClick={() => {
            setActiveTab("individual");
          }}
        >
          Individual
        </button>
        <button
          className={`px-4 py-2  ${
            activeTab === "corporate"
              ? "bg-white border-t border-l border-r shadow-sm"
              : "bg-gray-100"
          }`}
          onClick={() => {
            setActiveTab("corporate");
          }}
        >
          Corporate
        </button>
      </div>

      {/* Info alert */}
      <div className="flex flex-wrap items-center justify-between gap-3 mt-2">
        <div className="flex flex-col mb-2 sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
          <span className="text-sm font-semibold text-[#464646]">
            Number Of Trustees Within Your Trust:
          </span>
          <span className="text-sm font-medium text-black">
            <div className="font-semibold">
              <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1 border  rounded-md bg-white shadow-md">
                {/* Remove last row */}
                {isEdit && (
                  <>
                    <button
                      onClick={() => {
                        if (activeTab === "corporate") {
                          setCorporates((prev) =>
                            prev.length ? prev.slice(0, -1) : prev,
                          );
                        } else {
                          setIndividuals((prev) =>
                            prev.length ? prev.slice(0, -1) : prev,
                          );
                        }
                      }}
                      className="text-black px-2"
                    >
                      <Minus size={18} />
                    </button>

                    {/* Count display */}
                    <span className="text-sm font-medium bg-black text-white p-2">
                      {activeTab === "corporate"
                        ? corporates.length.toString().padStart(2, "0")
                        : individuals.length.toString().padStart(2, "0")}
                    </span>

                    {/* Add new row */}
                    <button
                      onClick={() =>
                        activeTab === "corporate"
                          ? addCorporate()
                          : addIndividual()
                      }
                      className="text-black px-2"
                    >
                      <Plus size={18} />
                    </button>
                  </>
                )}
                {!isEdit && (
                  <>
                    <span className="text-sm font-medium bg-black text-white p-2">
                      {activeTab === "corporate"
                        ? corporates.length.toString().padStart(2, "0")
                        : individuals.length.toString().padStart(2, "0")}
                    </span>
                  </>
                )}
              </div>
            </div>
          </span>
        </div>
        {activeTab === "corporate" && (
          <>
            {isEdit && (
              <button
                onClick={addCorporate}
                className="bg-black text-sm text-white px-4 py-2 rounded-md whitespace-nowrap"
              >
                + Add Corporate
              </button>
            )}
          </>
        )}
      </div>

      {/* Corporate Tab */}
      {activeTab === "corporate" && (
        <div className="space-y-2">
          {corporates.map((corp, ci) => (
            <>
              <div className="hidden md:block bg-[#EDEDED] border rounded-md shadow-sm">
                <div className="grid grid-cols-[40px_180px_200px_160px_130px_100px] px-4 py-3 border-b text-sm font-medium text-[#888888]">
                  <div>No.</div>
                  <div>Type of Trustee</div>
                  <div>Company Name</div>
                  <div>Beneficial Owner</div>
                  {isEdit && isInviteeTrustee && (
                    <>
                      <div>Add Director</div>
                      <div className="text-center"></div>
                    </>
                  )}
                </div>
              </div>
              <div key={corp.id} className="relative">
                {/* Corporate Row */}
                <div className="bg-[#F9F9F9]  rounded-md shadow-sm relative flex items-center">
                  {/* Hierarchy line for corporate node */}
                  <div className="absolute left-0 top-0 bottom-0 w-8 flex flex-col items-center"></div>

                  {/* Main Grid Content */}
                  <div className="grid md:grid-cols-[40px_150px_180px_140px_160px_300px] bg-[#F9F9F9] text-sm px-4 py-3 gap-4 w-full items-center">
                    <div className="text-sm font-medium">
                      {(ci + 1).toString().padStart(2, "0")}
                    </div>
                    <div className="text-sm font-medium">Corporate</div>
                    <div>
                      <input
                        className={`border w-full p-2 rounded-xl text-sm ${
                          corp.errors?.companyName ? "border-red-500" : ""
                        }`}
                        value={corp.companyName}
                        disabled={!isEdit}
                        onChange={(e) =>
                          updateCorporateField(
                            ci,
                            "companyName",
                            e.target.value,
                          )
                        }
                        placeholder="Company Name"
                      />
                      {corp.errors?.companyName && (
                        <p className="text-red-500 text-xs mt-1">
                          {corp.errors.companyName}
                        </p>
                      )}
                    </div>
                    <div>
                      <button
                        onClick={() => toggleBeneficial(ci)}
                        disabled={!isEdit}
                        className={`w-12 h-6 rounded-full p-1 flex items-center ${
                          corp.beneficialOwner
                            ? "bg-[#75E380] justify-end"
                            : "bg-[#E4E4E7] justify-start"
                        }`}
                      >
                        <div className="w-4 h-4 bg-white rounded-full shadow" />
                      </button>
                    </div>
                    {isEdit && isInviteeTrustee && (
                      <div>
                        <button
                          onClick={() => addDirector(ci)}
                          className="bg-white text-[#005A9C] border px-3 py-2 font-medium rounded-xl text-sm w-full shadow-lg hover:shadow"
                        >
                          + Add Director
                        </button>
                      </div>
                    )}
                    {isEdit && !isInviteeTrustee && !isShareholder && (
                      <div>
                        {corp.corporateId && (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              // dispatch(clearStepStatusShareholder());
                              // dispatch(clearCurrentStepShareholder());
                              let redirectState = {
                                path: `/onboarding-shareholder/${corp.corporateId}/2/trustee/${isShareholder}`,
                                state: {
                                  from: location.pathname,
                                },
                              };
                              sessionStorage.setItem(
                                "redirectAfterLogin",
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                `/onboarding-shareholder/${corp.corporateId}/2/trustee/${isShareholder}`,
                                {
                                  state: {
                                    from: location.pathname,
                                  },
                                },
                              );
                            }}
                            className="bg-white text-[#005A9C] border px-3 py-2 font-medium rounded-xl text-sm w-full shadow-lg hover:shadow"
                          >
                            Fill Application
                          </button>
                        )}
                      </div>
                    )}
                    <div className="flex justify-between md:justify-center gap-6 mt-2 md:mt-0">
                      {isEdit && (
                        <button
                          onClick={() => removeCorporate(ci)}
                          className="text-red-500"
                          title="Remove"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete"
                            className="h-4 w-4"
                          />
                        </button>
                      )}
                      {corp?.directors?.length > 0 && (
                        <button
                          onClick={() => toggleCorporateExpand(ci)}
                          title="Expand/Collapse"
                        >
                          {corp.expanded ? (
                            <img
                              src="/expanded-black.svg"
                              alt="Star Icon"
                              className="h-4 w-4"
                            />
                          ) : (
                            <img
                              src="/down-grey-steps.svg"
                              alt="Star Icon"
                              className="h-4 w-4"
                            />
                          )}
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                {/* Directors Section */}
                {corp.expanded && corp.directors.length > 0 && (
                  <>
                    {" "}
                    <div className="bg-[#F3F7FB] px-3 py-2 text-center rounded-md text-sm font-medium">
                      {corp.companyName} Directors
                    </div>
                    <div className="hidden md:block bg-[#F3F7FB] pl-8">
                      <div className="grid grid-cols-[60px_180px_200px_200px_150px_400px_200px] px-4 py-3 border-b text-sm font-medium text-[#888888]">
                        <div>No.</div>
                        <div>First Name</div>
                        <div>Last Name</div>
                        <div>Email Address</div>
                        <div>Phone Number</div>
                        <div>Managing Member</div>
                        <div className="text-center"></div>
                      </div>
                    </div>
                    <div className="ml-8  pl-4">
                      {corp.directors.map((d, di) => (
                        <>
                          <div
                            key={d.id}
                            className="relative flex items-start py-1 "
                          >
                            {/* Connector line from parent */}
                            <div
                              className={`absolute border-l-2 border-[#C6DFF1] left-[-18px] top-0 bottom-0  flex flex-col items-start ${
                                di === corp.directors.length - 1
                                  ? "h-[50%]"
                                  : "h-full"
                              }`}
                            >
                              {/* Vertical line */}
                              <div className={`w-[2px]`}></div>

                              {/* Arrow */}
                              <div className="relative w-3 h-3 mt-6">
                                <img
                                  src="/arrow-hierarchy.svg"
                                  alt="Arrow"
                                  className="w-3 h-3"
                                />
                              </div>
                            </div>

                            <div className="grid md:grid-cols-[40px_150px_180px_180px_160px_100px] bg-[#EEF7FD] p-2 gap-4 w-full items-center">
                              <div className="text-sm font-medium">
                                {(di + 1).toString().padStart(2, "0")}
                              </div>
                              <div>
                                <input
                                  className="border rounded-xl px-3 py-2 text-sm w-full"
                                  value={d.first_name}
                                  disabled={!isEdit}
                                  onChange={(e) =>
                                    updateDirectorField(
                                      ci,
                                      di,
                                      "firstName",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="First Name"
                                />
                              </div>
                              <div>
                                <input
                                  className="border rounded-xl px-3 py-2 text-sm w-full"
                                  value={d.last_name}
                                  disabled={!isEdit}
                                  onChange={(e) =>
                                    updateDirectorField(
                                      ci,
                                      di,
                                      "lastName",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Last Name"
                                />
                              </div>
                              <div>
                                <input
                                  className="border rounded-xl px-3 py-2 text-sm w-full"
                                  value={d.email}
                                  disabled={!isEdit}
                                  onChange={(e) =>
                                    updateDirectorField(
                                      ci,
                                      di,
                                      "email",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Email"
                                />
                              </div>
                              <div>
                                <input
                                  className="border rounded-xl px-3 py-2 text-sm w-full"
                                  value={d.country_code + d.mobile_number}
                                  disabled={!isEdit}
                                  onChange={(e) =>
                                    updateDirectorField(
                                      ci,
                                      di,
                                      "phone",
                                      e.target.value,
                                    )
                                  }
                                  placeholder="Phone"
                                />
                              </div>
                              <div className="flex justify-center">
                                <input
                                  type="radio"
                                  name={`managing-${ci}`}
                                  disabled={!isEdit}
                                  checked={d.managing_member}
                                  onChange={() => setManagingMember(ci, di)}
                                  className="h-4 w-4"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </>
          ))}
        </div>
      )}

      {/* Individual Tab */}
      {activeTab === "individual" && (
        <div className="bg-white border rounded-md p-3">
          <div className="overflow-x-auto">
            <table className="min-w-[800px] w-full text-sm">
              <thead className="bg-[#F9F9F9] text-labelColour text-xs">
                <tr>
                  <th className="p-2 w-[40px]"></th>
                  <th className="p-2">First Name</th>
                  <th className="p-2">Last Name</th>
                  <th className="p-2">Email Address</th>
                  <th className="p-2">Mobile Number</th>
                  <th className="p-2">Beneficial Owner</th>
                  <th className="p-2">Managing Member</th>
                  <th className="p-2 w-[40px]"></th>
                </tr>
              </thead>
              <tbody>
                {individuals.map((m, i) => (
                  <tr key={m.id} className="border-t">
                    <td className="p-2 font-medium text-labelColour">
                      {(i + 1).toString().padStart(2, "0")}
                    </td>
                    <td className="p-2">
                      <input
                        className={`border w-full p-2 rounded-xl text-sm ${
                          m.errors?.firstName ? "border-red-500" : ""
                        }`}
                        value={m.firstName}
                        disabled={!isEdit}
                        onChange={(e) =>
                          updateIndividualField(
                            i,
                            "firstName",
                            e.target.value,
                            validateRequired(
                              e.target.value,
                              "First name is required",
                            ),
                          )
                        }
                      />
                      {m.errors?.firstName && (
                        <span className="text-red-500 text-xs mt-1 block">
                          {m.errors.firstName}
                        </span>
                      )}
                    </td>
                    <td className="p-2">
                      <input
                        className={`border w-full p-2 rounded-xl text-sm ${
                          m.errors?.lastName ? "border-red-500" : ""
                        }`}
                        value={m.lastName}
                        disabled={!isEdit}
                        onChange={(e) =>
                          updateIndividualField(
                            i,
                            "lastName",
                            e.target.value,
                            validateRequired(
                              e.target.value,
                              "Last name is required",
                            ),
                          )
                        }
                      />
                      {m.errors?.lastName && (
                        <span className="text-red-500 text-xs mt-1 block">
                          {m.errors.lastName}
                        </span>
                      )}
                    </td>
                    <td className="p-2">
                      <input
                        className={`border w-full p-2 rounded-xl text-sm ${
                          m.errors?.email ? "border-red-500" : ""
                        }`}
                        value={m.email}
                        disabled={!isEdit}
                        onChange={(e) =>
                          updateIndividualField(
                            i,
                            "email",
                            e.target.value,
                            validateEmail(e.target.value),
                          )
                        }
                      />
                      {m.errors?.email && (
                        <span className="text-red-500 text-xs mt-1 block">
                          {m.errors.email}
                        </span>
                      )}
                    </td>
                    <td className="p-2">
                      <div className="flex flex-col">
                        <div
                          className={`flex items-center border rounded-xl overflow-hidden ${
                            m.errors?.mobile ? "border-red-500" : ""
                          }`}
                        >
                          <select
                            disabled={!isEdit}
                            className="px-2 text-sm text-[#888888] font-medium bg-transparent outline-none"
                            value={m.countryCode}
                            onChange={(e) =>
                              updateIndividualField(
                                i,
                                "countryCode",
                                e.target.value,
                              )
                            }
                          >
                            {countries.map((c) => (
                              <option key={c.code} value={c.dialCode}>
                                {c.code} ({c.dialCode})
                              </option>
                            ))}
                          </select>
                          <input
                            className={`outline-none p-2 text-sm w-full ${
                              m.errors?.mobile ? "border-red-500" : ""
                            }`}
                            placeholder="Mobile"
                            value={m.mobile}
                            disabled={!isEdit}
                            onChange={(e) => {
                              updateIndividualField(
                                i,
                                "mobile",
                                e.target.value,
                                validateMobile(m.countryCode, e.target.value),
                              );
                            }}
                          />
                        </div>
                        {m.errors?.mobile && (
                          <span className="text-red-500 text-xs mt-1">
                            {m.errors.mobile}
                          </span>
                        )}
                      </div>
                    </td>

                    <td className="p-2 text-center">
                      <button
                        onClick={() => toggleBeneficialIndividiual(i)}
                        disabled={!isEdit}
                        className={`w-12 h-6 rounded-full p-1 flex items-center ${
                          m.beneficialOwner
                            ? "bg-[#75E380] justify-end"
                            : "bg-[#E4E4E7] justify-start"
                        }`}
                      >
                        <div className="w-4 h-4 bg-white rounded-full shadow" />
                      </button>
                    </td>
                    <td className="p-2 text-center">
                      <input
                        type="radio"
                        name="managing-individual"
                        checked={m.managing}
                        disabled={!isEdit}
                        onChange={() => setManagingIndividual(i)}
                      />
                    </td>
                    {isEdit && (
                      <td className="p-2 text-center">
                        <button
                          onClick={() => removeIndividual(i)}
                          className="text-red-500"
                        >
                          <img
                            src="/trash.svg"
                            alt="Delete"
                            className="h-4 w-4"
                          />{" "}
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {isEdit && (
            <div className="px-4 py-3 flex justify-center ">
              <button
                onClick={addIndividual}
                className="flex items-center gap-2 text-[#005A9C] rounded-md font-medium text-sm hover:underline border-2 border-dashed p-2"
              >
                <img
                  src="/add-darkBlue.svg"
                  alt="Add Icon"
                  className="w-5 h-5"
                />
                Add New
              </button>
            </div>
          )}
        </div>
      )}

      {/* Save */}
      {isEdit && activeTab === "individual" && (
        <div className="flex justify-end mt-6">
          <button
            className={`px-6 py-2 rounded-full text-white ${"bg-black hover:bg-gray-900"}`}
            onClick={(e) => {
              e.preventDefault();
              const hasErrors = individuals.some((m) =>
                Object.values(m.errors || {}).some(Boolean),
              );

              if (hasErrors) {
                showToast("Please fix errors before continuing", "error");
                return;
              }
              setLoading(true);
              handleAddIndividuals(e);
            }}
          >
            Save
          </button>
        </div>
      )}
      {activeTab === "individual" && individuals.length > 0 && (
        <>
          <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Signatory Type */}
            <div className="flex flex-col px-2 pt-4">
              <Dropdown
                label={
                  <>
                    Select Signatory Type
                    <span className="text-red-500">*</span>
                  </>
                }
                disabled={isEdit ? false : true}
                options={signatoryTypeData}
                onSelect={handleSelectSignatoryType}
                preselectedValue={preSelectedSignatoryType}
              />
            </div>

            {/* Signatories */}
            <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
              {signatoryType === 1 && (
                <Dropdown
                  label={
                    <>
                      Select Signatory<span className="text-red-500">*</span>
                    </>
                  }
                  disabled={isEdit ? false : true}
                  options={signatoriesData}
                  onSelect={handleSelectSignatory}
                />
              )}
              {signatoryType === 2 && (
                <div className="">
                  <label className="block mb-2 text-sm text-gray-700">
                    Select Signatories<span className="text-red-500">*</span>
                  </label>
                  <Select
                    options={options}
                    isMulti
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    isDisabled={isEdit ? false : true}
                    components={{ Option, DropdownIndicator }}
                    onChange={(selected) => {
                      // 1️⃣ Update local / parent state
                      setSelectedOptions(selected);

                      // 2️⃣ Update Redux
                      dispatch(
                        updateField({
                          path: "selectedOptions",
                          value: selected || [],
                        }),
                      );
                    }}
                    allowSelectAll={true}
                    value={selectedOptions}
                    className="text-sm rounded-md w-full"
                    placeholder=""
                    styles={customStyles}
                  />
                  {selectedOptions.length === 0 && (
                    <label className="block mt-1 text-xs text-[#FF5050] flex items-center">
                      <img
                        src="/danger.svg"
                        alt="alert Icon"
                        className="h-4 w-4 mr-1"
                      />
                      Please select at least one signatory.
                    </label>
                  )}
                </div>
              )}

              {signatoryType === 3 && (
                <div className="mt-2">
                  <label className="block mb-2 text-sm text-gray-700">
                    Select Signatories <span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1 border rounded-md border-gray-300 p-2 flex flex-wrap gap-2">
                    {options.map((opt, index) => (
                      <div
                        key={index}
                        className="flex items-center bg-[#FCFCFC] text-gray-700 text-sm px-3 py-1 rounded-lg border shadow-sm"
                      >
                        <span>{opt.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* File Upload */}
            <div className="flex flex-col px-2 pt-4">
              <LabelWithStatus
                id="contracttype"
                label={fieldLabelMap.board_resolution_file}
                required={true}
                fieldData={fileAttorney}
                handleStatusClick={handleStatusClick}
              />
              <label className="border-2 border-dashed rounded-lg p-6 block text-center cursor-pointer flex flex-col items-center">
                <input
                  type="file"
                  id="fileUpload"
                  accept=".pdf,.png,.jpeg"
                  onChange={handleFileChangeAttorney}
                  disabled={fileAttorney.status == "approved" || !isEdit}
                  className="hidden"
                />
                <img
                  src="/folder-add.svg"
                  alt="Upload Icon"
                  className="h-4 w-4"
                />
                <p className="mt-2 text-gray-500 text-sm">
                  Drag & Drop <br /> or{" "}
                  <span className="underline">Click to Upload</span>
                </p>
              </label>
              <div className="mt-2 flex gap-2 flex-wrap text-xs">
                {["PNG", "JPEG", "PDF", "< 10 MB"].map((item, idx) => (
                  <span
                    key={idx}
                    className="bg-[#8E8E8E] text-white px-2 py-1 rounded-md"
                  >
                    {item}
                  </span>
                ))}
              </div>

              {fileAttorney && fileAttorney.value && (
                <div
                  className={`${
                    fileAttorney.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : "border"
                  }  mt-4 bg-white  shadow-md rounded-lg flex items-center justify-between px-3 py-2`}
                >
                  {" "}
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      handleFileClick(e, fileAttorney.value);
                    }}
                    className="flex flex-col"
                  >
                    <span className="text-black underline cursor-pointer">
                      {fileAttorney.value.file_name}
                    </span>
                    <span className="text-[#46DA55] text-xs">
                      Upload Completed
                    </span>
                  </div>
                  <button
                    onClick={handleDeleteFile}
                    className="text-red-500 flex-shrink-0 font-semibold"
                  >
                    <img src="/trash.svg" alt="Delete" className="h-4 w-4" />
                  </button>
                </div>
              )}
            </div>
          </div>

          <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
            <h1 className="text-lg font-medium mb-2">Transaction Limit</h1>
          </div>
          <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Signatory Type */}
            <div className="flex flex-col px-2 pt-4">
              <Dropdown
                label={
                  <>
                    Duration<span className="text-red-500">*</span>
                  </>
                }
                disabled={isEdit ? false : true}
                options={limitData}
                onSelect={handleSelectDurationType}
                preselectedValue={preSelectedDurationType}
              />
            </div>

            <div className="flex flex-col px-2 pt-4 md:border-r md:border-t-0 md:border-l border-gray-300">
              <div>
                <LabelWithStatus
                  id="minimumInvestment"
                  label={fieldLabelMap.transaction_limit_amount}
                  required={true}
                  fieldData={minimumInvestment}
                  handleStatusClick={handleStatusClick}
                />
                <input
                  type="text"
                  name="amountInDollars"
                  value={
                    isFocusedAccountFee
                      ? minimumInvestment.value
                      : isEdit
                        ? formatNumber(minimumInvestment.value)
                        : formatNumber(minimumInvestment)
                  }
                  ref={inputRefAccountFee}
                  onChange={(e) => {
                    if (!isFocusedAccountFee) return;
                    handleChangeAmountFee(e, e.target.value);
                  }}
                  onFocus={() => setIsFocusedAccountFee(true)}
                  onBlur={() => setIsFocusedAccountFee(false)}
                  disabled={minimumInvestment.status == "approved" || !isEdit}
                  className={`${
                    minimumInvestment.status == "rejected"
                      ? "border-[#FF5050] border-2"
                      : ""
                  } rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline`}
                />
              </div>
            </div>

            <div className="flex flex-col px-2 pt-4">
              <div className="w-full max-w-xs relative" ref={dropdownRef}>
                <LabelWithStatus
                  id="customDate"
                  label={fieldLabelMap.transaction_limit_expiry}
                  required={true}
                  fieldData={customDate}
                  handleStatusClick={handleStatusClick}
                />
                {/* Main Box */}
                <div className="font-medium relative w-full border border-gray-300 rounded-md flex items-center bg-white">
                  {/* Visible Input (styled like text, no default calendar) */}
                  <input
                    type="text"
                    readOnly
                    value={
                      selected === "custom"
                        ? formatDate(customDate.value) || "DD/MM/YYYY"
                        : selected === "never"
                          ? "Never Expire"
                          : ""
                    }
                    placeholder="DD/MM/YYYY"
                    disabled={customDate.status == "approved" || !isEdit}
                    className={`${
                      customDate.status == "rejected"
                        ? "border-[#FF5050] border-2"
                        : ""
                    } w-full px-3 py-2 text-sm rounded-md bg-white text-black  cursor-default`}
                  />

                  {/* Hidden Date Input (used for real selection) */}
                  <input
                    ref={dateInputRef}
                    type="date"
                    value={customDate.value}
                    disabled={isEdit ? false : true}
                    onChange={(e) => {
                      setCustomDate({
                        ...customDate,
                        value: e.target.value,
                      });
                      dispatch(
                        updateField({
                          path: "customDate",
                          value: {
                            ...customDate,
                            value: e.target.value,
                          },
                        }),
                      );
                    }}
                    className="absolute right-8 top-1/2 -translate-y-1/2 opacity-0 w-6 h-6 cursor-pointer"
                  />

                  {/* Calendar Icon (only when "custom" is selected) */}
                  {selected === "custom" && (
                    <button
                      type="button"
                      onClick={() => dateInputRef.current.showPicker()}
                      disabled={isEdit ? false : true}
                      className="absolute right-8 top-1/2 -translate-y-1/2 p-1"
                    >
                      <img
                        src="/calendar.svg"
                        alt="Calendar Icon"
                        className="w-4 h-4"
                      />
                    </button>
                  )}

                  {/* Dropdown Arrow */}
                  <button
                    type="button"
                    onClick={() => setIsOpen(!isOpen)}
                    disabled={isEdit ? false : true}
                    className="absolute right-2 top-1/2 -translate-y-1/2 p-1 h-5 w-5"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-black"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fillRule="evenodd"
                        d="M5.23 7.21a.75.75 0 011.06-.02L10 10.69l3.71-3.5a.75.75 0 111.04 1.08l-4 3.75a.75.75 0 01-1.04 0l-4-3.75a.75.75 0 01-.02-1.06z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </button>
                </div>

                {/* Dropdown Options */}
                {isOpen && (
                  <div className="absolute left-0 top-full mt-1 w-full bg-white border border-gray-300 rounded-md shadow-lg z-[9999]">
                    {optionsdate.map((option) => (
                      <div
                        key={option.value}
                        onClick={() => handleSelect(option)}
                        className="px-3 py-2 cursor-pointer hover:bg-black hover:text-white text-sm"
                      >
                        {option.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {isEdit && activeTab === "corporate" && (
        <div className="flex justify-end mt-6">
          <button
            className={`px-6 py-2 rounded-full text-white ${"bg-black hover:bg-gray-900"}`}
            onClick={(e) => {
              e.preventDefault();
              const hasCorporateErrors = corporates.some(
                (c) => !c.companyName.trim() || c.errors?.companyName,
              );
              if (corporates.length == 0 || hasCorporateErrors) {
                showToast("Please fill the data", "error");
                return;
              }
              setLoading(true);
              handleAddCorporates(e);
            }}
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
}
